import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { AttendanceLocalUser } from "../../../../@types/attendance-local-user";
import { apisiseci } from "../../../api";

export function useAttendanceLocalUserDelete(id: AttendanceLocalUser["id"]) {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "user", "delete", id],
        mutationFn: async () => {
            return apisiseci.delete(`/cms/u_usuarios/${id}/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
        },
        onSuccess: async () => {
            toast.success("Usuário removido com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "users"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "user", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "guiche", "list"],
                }),
            ]);
        },
        onError: (error: AxiosError) => {
            const { status } = error?.response;

            if (status === 400) {
                toast.error(error.response?.data?.detail);
            } else {
                toast.error("Algo deu errado, tente novamente!");
            }
        },
    });

    return mutation;
}
